import axios from 'axios'
import { base } from './config'

const endpoints = {
  'token': '/backend/auth',
  'company': '/backend/company',
  'companyUpdate': '/backend/company/{1}',
  'companyCrane': '/backend/company/{1}/crane/{2}',
  'companyPass': '/backend/company/{1}/pass',
  'companyRefuse': '/backend/company/{1}/refuse',
  'companyRemove': '/backend/company/{1}',
  'setting': '/api/setting',
  'cranes': '/backend/crane',
  'craneWeight': '/backend/crane/{1}/weight',
  'craneUpdate': '/backend/crane/{1}',
  'weightRemove': '/backend/crane/weight/{1}',
  'craneWeightUpdate': '/backend/crane/{1}/weight/{2}',
  'brand': '/backend/brand',
}

const request = (method, url, params) => {
  let config = {
    url: url,
    method: method,
  }

  if (method == 'get') {
    config.params = params
  } else {
    config.data = params
  }

  let tokenInfo = localStorage.getItem('token');
  tokenInfo = tokenInfo ? JSON.parse(tokenInfo) : null;
  if (tokenInfo) {
    config.headers = {'Authorization': tokenInfo.token}
  }

  return new Promise((resolve, reject) => {
    axios.request(config).then((response) => {
      if (response.data.code == 0) {
        return resolve(response.data.data);
      } else {
        return reject(response.data.errmsg);
      }
    }).catch(() => {
      return reject('请求错误');
    })
  });
}

class Api {
  constructor (base, endpoints) {
    this.base = base
    this.endpoints = endpoints
  }

  url (endpoint_name, ...args) {
    let endpoint = this.endpoints[endpoint_name]
    if (!endpoint) {
      throw Error('endpoint not foud!')
    }
    if (args.length > 0) {
      let i = 0
      let arg
      while ((arg = args.shift())) {
        i++
        endpoint = endpoint.replace('{' + i + '}', arg)
      }
    }
    return this.base + endpoint
  }

  get (url, params) {
    return request('get', url, params)
  }

  post (url, params) {
    return request('post', url, params)
  }

  patch (url, params) {
    return request('patch', url, params)
  }

  delete (url, params) {
    return request('delete', url, params)
  }

  put (url, params) {
    return request('put', url, params)
  }
}

export default new Api(base, endpoints)
